import { shallowMemoize } from '@sail/utils';
import { createIntl, createIntlCache } from 'react-intl';
import { DEFAULT_LOCALE } from '../internal/constants';
import { handleReactIntlError } from '../internal/errors/handleReactIntlError/handleReactIntlError';
import getLocaleData from '../internal/getLocaleData';
import proxiedMessages from '../internal/message-formatter/proxiedMessages';
const cache = createIntlCache();
const createIntlFromLocaleData = shallowMemoize((localeData, reports, analytics)=>{
    const { locale, messages = {} } = localeData;
    const intlConfig = {
        defaultLocale: DEFAULT_LOCALE,
        // This is the configured locale for viewing. `react-intl` does not love
        // fake locales, so we tell it that we're default.
        locale,
        // This is an object with every translated message in it. Messages that
        // aren't present fallback to the default locale `en-US`, even in
        // production.
        messages: proxiedMessages(messages),
        // TODO: remove it or not?
        textComponent: 'span',
        // Handle all the errors for reporting and logging purposes. This method
        // should NEVER throw errors or it will break react-intl fallback
        // mechanisms.
        onError: handleReactIntlError.bind(undefined, reports, analytics, locale)
    };
    return createIntl(intlConfig, cache);
});
const createIntlWithLocale = (requestedLocale, config, reports, analytics)=>{
    const localeData = getLocaleData(requestedLocale, config, reports);
    const intlWithLocale = createIntlFromLocaleData(localeData, reports, analytics);
    return intlWithLocale;
};
export default createIntlWithLocale;

//# sourceMappingURL=createIntlWithLocale.js.map